import { reactive } from 'vue';
import { getWatchfaceDeviceRadius } from './use-watchface-devices';
import { useWatchfaceScreenShot } from '.';
import { WatchfaceService } from '@/services/watchface';

const previewImgs = reactive<Record<string, string>>({});
export const useHomePreviewImgs = () => {
  const { screenshot } = useWatchfaceScreenShot();

  const generatePreview = async (path: string, deviceType: string) => {
    // 优先使用preview目录下的预览图
    const service = new WatchfaceService(path);
    // 如果没有，则使用截图
    const _fileNew =
      (await service.preview.getPreviewImage('market-preview.png')) ??
      ((await screenshot(path, {
        clipRound: getWatchfaceDeviceRadius(deviceType ?? '')
      })) as string);
    if (_fileNew) {
      previewImgs[path] = _fileNew;
    }
  };

  const clear = (path: string) => {
    previewImgs[path] = '';
  };

  const generatePreviews = async (
    items: { path: string; deviceType?: string }[]
  ) => {
    let index = 0;
    const step = 5;
    while (index < items.length) {
      const pros: Promise<void>[] = [];
      for (let i = index; i < index + step; i++) {
        const { path, deviceType } = items[i] ?? {};
        if (!path) continue;
        if (previewImgs[path]) continue;
        pros.push(generatePreview(path, deviceType ?? ''));
      }
      await Promise.all(pros);
      index = index + step;
    }
  };

  return {
    previewImgs,
    generatePreviews,
    clear
  };
};
